import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {DeliveryZoneForm} from "./DeliveryZoneForm";

export const DeliveryZoneEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <DeliveryZoneForm />
    </DefaultEdit>
  );
};
